import React, { Component, PropTypes } from 'react'
import { Provider } from 'react-redux'
import { CACHE_VERSION } from '../../constants/config'
import { getCookie } from '../../helpers/unit'
import $$CACHE from '../../helpers/cache'
import Routes from '../routes/df-day.jsx'
import Framework from '../../containers/pc-day/Framework.jsx'

// antd 组件国际化
import ConfigProvider from 'antd/lib/config-provider';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
require('../../styles/themes/df-day/style.scss');


window.CLIENT_MODE = 'PC';
export default class Root extends Component {

  componentWillMount() {
    // 本地缓存控制
    if (!$$CACHE.get('cache_version') || $$CACHE.get('cache_version').data != CACHE_VERSION ) {
      // 清除所有本地缓存
      $$CACHE.clear();
      // 设置新的本地缓存版本号
      $$CACHE.put('cache_version', CACHE_VERSION, 30);
    }
    // 遍历删除过期的缓存数据
    $$CACHE.removeExpired();
    window.AUTH_TOKEN = getCookie('auth');
    window.AUTH_EXPIRESIN = getCookie('auth-expires-in');
    window.STORE = {};
    window.VERSION = 'X';
    window.CLIENT_INFOS = JSON.parse(getCookie('client-infos')) || {source: 'web'}
    window.METHODS = {};
    window.DISABLE_HTTP_LOG = true;

  }

  render() {
    const { store } = this.props
    return (
      <Provider store={store}>
        <ConfigProvider locale={zh_CN} >
          <Framework>
            <Routes />
          </Framework>
        </ConfigProvider>
      </Provider>
    )
  }
}

